module.exports = __webpack_public_path__ + "img/cb_2.34e7f209.png";